import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { DisableDefinitionsMenu } from '../../v2/definitions/body/disable-menu/DisableDefinitionMenu';
import { ReadingAidsMenuButton } from './reading-aids-menu-button';
import { ReadingAidsOptionsWrapper } from './styled';
export var ReadingAidsOptions = function ReadingAidsOptions() {
  var platformDisableOn = fg('kd_definitions_confluence_enable_platform');
  return /*#__PURE__*/React.createElement(ReadingAidsOptionsWrapper, null, platformDisableOn ? /*#__PURE__*/React.createElement(DisableDefinitionsMenu, null) : /*#__PURE__*/React.createElement(ReadingAidsMenuButton, null));
};